export default "__VITE_ASSET__BFDCdP4X__"